import { useCallback, useRef } from "react";

/**
 * Keep two scroll containers vertically in sync. Used to lock the TaskTable and
 * GanttTimeline scrollTop together so rows stay aligned.
 *
 * Returns { tableRef, ganttRef, onTableScroll, onGanttScroll }.
 */
export default function useSyncedScroll() {
  const tableRef = useRef(null);
  const ganttRef = useRef(null);
  const syncing = useRef(false);

  const onTableScroll = useCallback((e) => {
    if (syncing.current) return;
    syncing.current = true;
    if (ganttRef.current) ganttRef.current.scrollTop = e.target.scrollTop;
    syncing.current = false;
  }, []);

  const onGanttScroll = useCallback((e) => {
    if (syncing.current) return;
    syncing.current = true;
    if (tableRef.current) tableRef.current.scrollTop = e.target.scrollTop;
    syncing.current = false;
  }, []);

  return { tableRef, ganttRef, onTableScroll, onGanttScroll };
}
